import styled from "styled-components";
import moment from "moment";
import { Image } from "react-bootstrap";
import React from "react";

const DescriptionContainer = styled.div`
  text-align: center;
  font-size: 0.8rem;
  color: #123559;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 15rem;
  display: -webkit-box;
  word-wrap: break-word;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: 0;
`;

const TimestampContainer = styled.div`
  text-align: center;
  color: #123559;
`;

const ProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #123559;
  h1 {
    font-size: 16px;
    text-align: center;
    margin: 0;
  }
  h2 {
    font-size: 14px;
    margin: 0.5rem 0 0 0;
    text-align: center;
  }
`;

const ProfileContainer = styled.div`
  display: flex;
  align-self: center;
  justify-content: flex-start;
  align-items: flex-start;
  color: #123559;

  h1 {
    font-size: 18px;
    font-weight: 500;
    max-width: calc(15px * 12);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* number of lines to show */
    -webkit-box-orient: vertical;
    margin: 0;
  }
  h2 {
    font-size: 16px;
    font-weight: 300;
    max-width: calc(15px * 12);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* number of lines to show */
    -webkit-box-orient: vertical;
    margin: 0.25rem 0 0 0;
  }
`;

const ImageContainer = styled(Image)`
  margin-right: 1rem;
`;

const ContainerTable = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Description = (props: {
  description: string;
  doctorId?: string | undefined | null;
}) => {
  return (
    <ContainerTable>
      <DescriptionContainer title={props.description}>
        {props.description}
      </DescriptionContainer>
      {props.doctorId && (
        <DescriptionContainer title={props.doctorId}>
          ผู้ดูแล : {props.doctorId}
        </DescriptionContainer>
      )}
    </ContainerTable>
  );
};

export const Timestamp = (props: { timestamp: string | number | Date }) => {
  const date = moment(props.timestamp).format("DD/MM/YYYY");
  return <TimestampContainer>{date}</TimestampContainer>;
};

export const ProfileComponent = (props: {
  name: string;
  displayName: string;
  pictureUrl: string;
}) => {
  return (
    <ProfileContainer>
      <ImageContainer
        src={props.pictureUrl}
        width={40}
        height={40}
        roundedCircle
      />
      <div>
        <h1>{props.name}</h1>
        <h2>{props.displayName}</h2>
      </div>
    </ProfileContainer>
  );
};

export const Product = (props: {
  productName: string;
  productPrice: number;
  isCoupon?: boolean;
}) => {
  return (
    <ProductContainer>
      <h1>Package {props.productName}</h1>
      {props.isCoupon ? <h2>คูปอง</h2> :<h2>ราคา {props.productPrice} ฿</h2>}
    </ProductContainer>
  );
};
